function monthsFromNow(today, selectedExpirationMonth) {
  if (!today) {
    throw new TypeError(`monthsFromNow expects a date. got ${typeof today}`);
  }

  if (!selectedExpirationMonth) {
    return '';
  }

  let currentMonth = 0;

  // Check if today is a moment() instance,
  // otherwise treat it like a Date() object.
  if (typeof today.month === 'function') {
    currentMonth = today.month() + 1;
  } else {
    currentMonth = today.getMonth() + 1;
  }

  let difference = selectedExpirationMonth - currentMonth;

  // Patch the last year's (or beyond) calculation of the difference.
  // For example, puchase date of 12/13/2016, then select FEB, it should
  // be a difference of 2 months, but instead it calculates as -10, this
  // patch should do the trick for now, until the underlying problem is found.
  if (difference <= -9) {
    difference += 12;
  }

  // console.log('monthsFromNow called with', { today: today.toString(), selectedExpirationMonth, difference, currentMonth });

  if (difference === 1) {
    return '13 / 1 months';
  }

  if (difference === 2) {
    return '14 / 2 months';
  }

  if (difference === 3) {
    return '15 / 3 months';
  }

  if (difference > 3) {
    return `${difference} months`;
  }

  // if (difference < 0) {
  //   return monthsFromNow(today, Math.abs(difference -= 12));
  // }

  if (selectedExpirationMonth <= currentMonth) {
    return `${(selectedExpirationMonth + 12) - currentMonth} months`;
  }

  return '0';
}

export default monthsFromNow;
